import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Checkbox,
  TextField,
  MenuItem,
} from "@material-ui/core";

/** Ancho mínimo para que columnas no se compriman; el contenedor hace scroll horizontal en móvil. */
const TABLA_SESIONES_MIN_WIDTH = 720;

export default function TablaSesiones({ sesiones = [], onChange }) {

  const handleChange = (numero, campo, valor) => {
    const nuevasSesiones = sesiones.map(s =>
      s.numero === numero
        ? { ...s, [campo]: valor }
        : s
    );

    onChange(nuevasSesiones);
  };

  if (!sesiones.length) return null;

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      style={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        boxSizing: "border-box",
      }}
    >
      <Table size="small" style={{ minWidth: TABLA_SESIONES_MIN_WIDTH, tableLayout: "fixed" }}>
      <TableHead>
        <TableRow>
          <TableCell style={{ width: 56 }}>Sesión</TableCell>
          <TableCell align="center" style={{ width: 88 }}>Asistencia</TableCell>
          <TableCell align="center" style={{ width: 88 }}>Encuesta</TableCell>
          <TableCell align="center" style={{ width: 88 }}>Reporte</TableCell>
          <TableCell align="center" style={{ width: 120 }}>Nivel Riesgo</TableCell>
          <TableCell align="center" style={{ width: 110 }}>Consentimiento</TableCell>
          <TableCell align="center">Observaciones</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {sesiones.map((sesion) => (
          <TableRow key={sesion.numero}>
            <TableCell>{sesion.numero}</TableCell>

            <TableCell align="center">
              <Checkbox
                checked={sesion.asistencia || false}
                onChange={(e) =>
                  handleChange(sesion.numero, "asistencia", e.target.checked)
                }
              />
            </TableCell>

            <TableCell align="center">
              <Checkbox
                checked={sesion.encuesta || false}
                onChange={(e) =>
                  handleChange(sesion.numero, "encuesta", e.target.checked)
                }
              />
            </TableCell>

            <TableCell align="center">
              <Checkbox
                checked={sesion.reporte || false}
                onChange={(e) =>
                  handleChange(sesion.numero, "reporte", e.target.checked)
                }
              />
            </TableCell>

            <TableCell align="center" style={{ verticalAlign: "middle" }}>
              <TextField
                select
                size="small"
                fullWidth
                variant="outlined"
                margin="dense"
                value={sesion.nivel_riesgo || ""}
                onChange={(e) =>
                  handleChange(sesion.numero, "nivel_riesgo", e.target.value)
                }
              >
                <MenuItem value="">-</MenuItem>
                <MenuItem value="BAJO">Bajo</MenuItem>
                <MenuItem value="MEDIO">Medio</MenuItem>
                <MenuItem value="ALTO">Alto</MenuItem>
              </TextField>
            </TableCell>

            <TableCell align="center">
              {sesion.numero === 1 ? (
                <Checkbox
                  checked={sesion.consentimiento || false}
                  onChange={(e) =>
                    handleChange(sesion.numero, "consentimiento", e.target.checked)
                  }
                />
              ) : (
                "-"
              )}
            </TableCell>

            <TableCell align="left" style={{ verticalAlign: "top" }}>
              <TextField
                multiline
                rows={2}
                size="small"
                fullWidth
                variant="outlined"
                margin="dense"
                value={sesion.observaciones || ""}
                onChange={(e) =>
                  handleChange(sesion.numero, "observaciones", e.target.value)
                }
                inputProps={{ style: { fontSize: "0.85rem" } }}
              />
            </TableCell>

          </TableRow>
        ))}
      </TableBody>
    </Table>
    </TableContainer>
  );
}